import dynamic from "next/dynamic";

export const DynamicContent042 = dynamic(() => import("./Content042"), {
  suspense: true,
});
